module.exports = __webpack_public_path__ + "static/img/26.ba71da3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/26.jpg
// module id = GMEj
// module chunks = 0